/** @jsxImportSource @emotion/react */
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { accessAPI, formatFecha, TablaFiltrable } from "../../shared";

import { Accordion, AccordionTab } from "primereact/accordion";
import { Column } from "primereact/column";
import { Skeleton } from "primereact/skeleton";

const FILTROS = [{ campo: "_clienteText", label: "Cliente", labelPlural: "clientes" }];
const SEARCH_FIELDS = ["_procesoText", "_clienteText"];

export default function CertificadosVencidos({ toast }) {
  const [certificados, setCertificados] = useState();
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    accessAPI(
      "GET",
      "admin/destacados/certificadosvencidos",
      null,
      (respuesta) => {
        setCertificados(respuesta);
        setLoading(false);
      },
      (respuesta) => {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al cargar certificados vencidos",
          sticky: true
        });
        setLoading(false);
      }
    );
  }, [toast]);

  if (!loading && (!certificados || certificados.length === 0)) {
    return null;
  }

  if (loading) {
    return (
      <div css={{ marginTop: "1em" }}>
        <Skeleton width="100%" height="3.5rem" borderRadius="6px" />
      </div>
    );
  }

  const datos = (certificados || []).map((cert) => {
    const c = cert.proceso.cliente;
    const clienteText =
      c.nombrefantasia && c.nombrefantasia !== c.razonsocial
        ? `${c.razonsocial} (${c.nombrefantasia})`
        : c.razonsocial;
    return {
      ...cert,
      _procesoText: `${cert.proceso.nombre} - ${cert.proceso.nombrefantasia}`,
      _clienteText: clienteText
    };
  });

  return (
    <Accordion
      activeIndex={null}
      css={{
        marginTop: "1em",
        "& .p-accordion-header-link": { color: "black" },
        "& .p-toggleable-content": { transition: "max-height 0.15s ease" }
      }}
    >
      <AccordionTab
        header={`Vencimiento de certificados (${certificados.length})`}
      >
        <TablaFiltrable
          value={datos}
          filtros={FILTROS}
          searchFields={SEARCH_FIELDS}
          nombreArchivo="certificados_vencidos"
          onRowClick={(e) => {
            const url = `/proceso/${e.data.proceso.id}/certificado/${e.data.id}`;
            e.originalEvent.metaKey || e.originalEvent.ctrlKey
              ? window.open(url, "_blank")
              : navigate(url);
          }}
          emptyMessage="No hay certificados vencidos"
          css={{
            "& .p-datatable-tbody > tr": { cursor: "pointer" }
          }}
        >
          <Column header="Proceso" field="_procesoText" />
          <Column header="Cliente" field="_clienteText" />
          <Column
            header="Vencimiento"
            body={(cert) => {
              const vencido = new Date(cert.fechavencimiento) < new Date();
              return (
                <span css={vencido ? { color: "var(--rojo)", fontWeight: "bold" } : {}}>
                  {formatFecha(cert.fechavencimiento)}
                </span>
              );
            }}
            style={{ width: "10em" }}
          />
        </TablaFiltrable>
      </AccordionTab>
    </Accordion>
  );
}
